import { CSSProperties } from 'react';
import styled from '@emotion/styled';
import { mediaDesktop } from 'components/core/theme/breakpoints';
import { FCWithChildren } from 'helpers/types/FCWithChildren';

const Wrapper = styled.div<{ direction: 'row' | 'column' }>`
  padding: 17px;

  ${mediaDesktop} {
    padding: 24px;
  }

  display: flex;
  flex-direction: ${props => props.direction};
  align-items: center;
  justify-content: center;
  box-shadow:
    rgb(0 0 0 / 20%) 0px 2px 4px -1px,
    rgb(0 0 0 / 14%) 0px 4px 5px 0px,
    rgb(0 0 0 / 12%) 0px 1px 10px 0px;
  gap: 10px;
`;

export const FooterChildrenWrapper: FCWithChildren<{
  direction?: 'row' | 'column';
  style?: CSSProperties;
}> = ({ children, direction, style }) => {
  return (
    <Wrapper style={style} direction={direction ?? 'row'}>
      {children}
    </Wrapper>
  );
};
